import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import HelperFunctions from './assets/HelperFunctions.js'
import DeviceCheck from './assets/DeviceCheck.js'
import VueShepherd from 'vue-shepherd'

Vue.config.productionTip = false

const plugin = {
  install() {
    Vue.HelperFunctions = HelperFunctions;
    Vue.prototype.$HelperFunctions = HelperFunctions;
    Vue.DeviceCheck = DeviceCheck;
    Vue.prototype.$DeviceCheck = DeviceCheck;
  }
}

Vue.use(plugin);
Vue.use(VueShepherd);

export const EventBus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
